/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ct_ClientsInputs */

const en_ct_clients = /** @type {(inputs: Ct_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`clients`)
};

const ar_ct_clients = /** @type {(inputs: Ct_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عميل`)
};

const bn_ct_clients = /** @type {(inputs: Ct_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ক্লায়েন্ট`)
};

const de_ct_clients = /** @type {(inputs: Ct_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunden`)
};

const es_ct_clients = /** @type {(inputs: Ct_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`clientes`)
};

const fr_ct_clients = /** @type {(inputs: Ct_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`clients`)
};

const pt_ct_clients = /** @type {(inputs: Ct_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`clientes`)
};

const zh_ct_clients = /** @type {(inputs: Ct_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`客户`)
};

const tr_ct_clients = /** @type {(inputs: Ct_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`müşteri`)
};

const ru_ct_clients = /** @type {(inputs: Ct_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`клиентов`)
};

const pl_ct_clients = /** @type {(inputs: Ct_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`klientów`)
};

/**
* | output |
* | --- |
* | "clients" |
*
* @param {Ct_ClientsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const ct_clients = /** @type {((inputs?: Ct_ClientsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ct_ClientsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ct_clients(inputs)
	if (locale === "bn") return bn_ct_clients(inputs)
	if (locale === "de") return de_ct_clients(inputs)
	if (locale === "es") return es_ct_clients(inputs)
	if (locale === "fr") return fr_ct_clients(inputs)
	if (locale === "pt") return pt_ct_clients(inputs)
	if (locale === "zh") return zh_ct_clients(inputs)
	if (locale === "tr") return tr_ct_clients(inputs)
	if (locale === "ru") return ru_ct_clients(inputs)
	if (locale === "pl") return pl_ct_clients(inputs)
	return en_ct_clients(inputs)
});